import {Evaluation, EvaluationRestControllerApiFactory} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {useApiManager} from "../../../../components/utils/api";
import {TableCell} from "@mui/material";
import {COLOR_DISMISSED} from "../../../../components/layout/colors";
import {useParams} from "react-router-dom";
import {dateToString} from "../../../../components/utils/dates";
import {parsePathId} from "../../../../components/form/form_utils";

export const EvaluationListPage = () => {
	const apiManager = useApiManager();
	const params = useParams();
	const personId = parsePathId(params, "personId");

	const getColor = (value: number): string => {
		if (value < 0) value = 0;
		if (value > 40) value = 40;
		// Interpolar el matiz de rojo (0°) a verde (120°)
		const hue = (120 * value) / 40;
		return `hsl(${hue}, 100%, 30%)`;
	}

	const listConfig: AppListConfig<Evaluation> = {
		title: "Listado de evaluaciones",
		onClick: personId
			? "/app/admin/employee/person/" + personId + "/evaluation"
			: "/app/admin/employee/evaluation",
		headers: [
			{title: "Fecha"},
			{title: "Persona"},
			{title: "Rating", align: "right"},
		],
		decorator: (bean: Evaluation) => (
			<>
				<TableCell style={{color: bean.dismissed ? COLOR_DISMISSED : "inherit"}}>
					{dateToString(bean.evaluationDate)}
				</TableCell>
				<TableCell>
					{bean.person.surnames + ", " + bean.person.name}
				</TableCell>
				<TableCell align={"right"}>
					<div style={{color: getColor(bean.rating || 0)}}>
						{bean.rating?.toFixed(2)}
					</div>
				</TableCell>
			</>
		),
		supplier: async (currentPage, size, term, showDismissed) => {

			const ctrl = apiManager.factory(EvaluationRestControllerApiFactory);
			return ctrl.pageEvaluation(currentPage, size, undefined, personId,
				undefined, undefined, undefined, term, showDismissed);
		},
	};

	return (
		<>
			<AppList config={listConfig}/>
		</>
	);
};